<ng-template #rowActions let-item>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit({data: item, action: $event.valueOf()})" [actionData]="item"></action-menu>
</ng-template>

<data-table 
customCardClass="min-h-full h-full max-h-full overflow-auto"
[title]="detailsTitle()"
[rows]="data()" 
[columns]="columns" 
[actionsTemplate]="rowActions"
tableActionData="create"
[showActionButton]="true"
(tableActionClick)="actions[$event.valueOf()].emit({action: $event.valueOf()})">
  <select
    class="ml-2 p-2"
    (change)="onCompanyFilterChanged($event)">
    <option value="">All companies</option>

    @for (company of companies(); track company.id) {
      <option [value]="company.id">{{ company.name }}</option>
    }
  </select>
</data-table>